import { createContext, useContext, useMemo, useState } from "react";
import { initialSession, Session } from "../models/session";

export const SessionContext = createContext<[Session, (session: Session) => void]>([initialSession, () => {}]);
export const useSessionContext = () => useContext(SessionContext);

interface ISessionContextProviderProps {
  children: React.ReactNode;
}

const SessionContextProvider = ({ children }: ISessionContextProviderProps) => {
  const [sessionState, setSessionState] = useState<Session>(initialSession);

  const defaultSessionContext = useMemo(
    () => [sessionState, setSessionState] as [Session, typeof setSessionState],
    [sessionState]
  );

  return (
    <SessionContext.Provider value={defaultSessionContext}>
      {children}
    </SessionContext.Provider>
  );
};

export default SessionContextProvider;
